function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1504_16342)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.5 0.5L3.38611 13.7206V40.1322L26.5 53.5L49.6139 40.2794V13.7794L26.5 0.5ZM45.3444 37.5117L26.5 48.4061L7.65555 37.6265V16.3411L26.5 5.44667L45.3444 16.3706V37.5117Z",
  fill: "#99A6B0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.5 0.5L3.38611 13.7206L7.65555 16.3411L26.5 5.44667L45.3444 16.3411L49.6139 13.7206L26.5 0.5Z",
  fill: "url(#paint0_linear_1504_16342)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.5122 31.3431C37.2873 30.9729 36.9558 30.6794 36.5612 30.5009C35.3635 27.8865 33.5288 25.6145 31.2252 23.8932C28.9215 22.1719 26.2227 21.0563 23.376 20.6488L42.4471 9.62777L38.0128 7.08377L16.2946 19.6389C15.8727 19.8818 15.5428 20.2572 15.3563 20.707C15.1699 21.1567 15.1373 21.6554 15.2635 22.1256C15.3898 22.5957 15.6679 23.011 16.0546 23.3068C16.4413 23.6026 16.9149 23.7623 17.4017 23.7611C17.4915 23.7446 17.58 23.7219 17.6667 23.6934L18.0348 25.2333C20.8037 24.5804 23.7116 24.8748 26.2935 26.0694C28.8754 27.264 30.9822 29.2898 32.277 31.823L10.6383 44.328L15.055 46.8779L36.7055 34.3611C36.9942 34.1885 37.2382 33.9505 37.418 33.6662L37.6389 33.6132C37.6182 33.5278 37.5859 33.4513 37.5653 33.3659C37.7219 33.0499 37.799 32.7004 37.7897 32.3479C37.7805 31.9953 37.6852 31.6504 37.5122 31.3431Z",
  fill: "#99A6B0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.6012 27.0383C34.5238 27.0383 33.4707 27.3578 32.5749 27.9563C31.6791 28.5549 30.9809 29.4056 30.5686 30.4009C30.1563 31.3963 30.0485 32.4915 30.2586 33.5482C30.4688 34.6049 30.9876 35.5755 31.7494 36.3373C32.5112 37.0991 33.4818 37.6179 34.5385 37.8281C35.5951 38.0382 36.6904 37.9304 37.6858 37.5181C38.6811 37.1058 39.5318 36.4076 40.1304 35.5118C40.7289 34.616 41.0484 33.5629 41.0484 32.4855C41.0484 31.0408 40.4745 29.6553 39.453 28.6337C38.4314 27.6122 37.0459 27.0383 35.6012 27.0383ZM17.3986 16.0084C16.3213 16.0084 15.2681 16.3279 14.3723 16.9264C13.4765 17.525 12.7784 18.3757 12.3661 19.3711C11.9538 20.3664 11.8459 21.4617 12.0561 22.5183C12.2663 23.575 12.7851 24.5456 13.5469 25.3074C14.3087 26.0692 15.2793 26.588 16.3359 26.7982C17.3926 27.0084 18.4879 26.9005 19.4832 26.4882C20.4785 26.0759 21.3293 25.3777 21.9278 24.4819C22.5264 23.5861 22.8459 22.533 22.8459 21.4556C22.8459 20.0109 22.272 18.6254 21.2504 17.6038C20.2289 16.5823 18.8433 16.0084 17.3986 16.0084Z",
  fill: "url(#paint1_linear_1504_16342)"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1504_16342",
  x1: 26.5,
  y1: 16.3411,
  x2: 26.5,
  y2: 0.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.199,
  stopColor: "#99A6B0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#99A6B0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_1504_16342",
  x1: 26.4999,
  y1: 37.9327,
  x2: 26.4999,
  y2: 16.0673,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#99A6B0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.172,
  stopColor: "#99A6B0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#99A6B0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.662,
  stopColor: "#99A6B0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.975,
  stopColor: "#99A6B0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1504_16342"
}, /*#__PURE__*/React.createElement("rect", {
  width: 53,
  height: 53,
  fill: "99A6B0",
  transform: "translate(0 0.5)"
})));

const SvgAzureSynapseAnalytics = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 53,
  height: 54,
  viewBox: "0 0 53 54",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAzureSynapseAnalytics, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/azure-synapse-analytics.f22fcfcb.svg";
export { ForwardRef as ReactComponent };